import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StarRating from '../StarRating';
import { listReviews, setReviewHidden, deleteReview } from '../../lib/api/adminApi';

// Modération des avis : cacher / réafficher / supprimer.
function AdminReviews({ onAuthError }) {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    listReviews()
      .then(({ data }) => setList(data || []))
      .catch((err) => onAuthError && onAuthError(err))
      .finally(() => setLoading(false));
  }, [onAuthError]);

  useEffect(() => {
    load();
  }, [load]);

  const toggle = async (r) => {
    try {
      await setReviewHidden(r.id, !r.hidden);
      await load();
    } catch (err) {
      onAuthError && onAuthError(err);
    }
  };

  const remove = async (r) => {
    if (!window.confirm(t('reviews.admin_confirm_delete'))) return;
    try {
      await deleteReview(r.id);
      await load();
    } catch (err) {
      onAuthError && onAuthError(err);
    }
  };

  const visible = list.filter((r) => !r.hidden).length;

  return (
    <div className="rescue-admin">
      <div className="rescue-admin__head">
        <span className="rescue-admin__count">
          {t('reviews.admin_count', { count: list.length })}
          {list.length > 0 && ` · ${visible} ${t('reviews.admin_visible')}`}
        </span>
      </div>

      {loading ? (
        <p className="admin__empty">…</p>
      ) : list.length === 0 ? (
        <p className="admin__empty">{t('reviews.admin_empty')}</p>
      ) : (
        <ul className="rescue-list">
          {list.map((r) => (
            <li key={r.id} className={`rescue-item ${r.hidden ? 'is-pending' : ''}`}>
              <div className="rescue-item__main">
                <span className="rescue-item__title">
                  <StarRating value={r.rating} readOnly size="sm" />{' '}
                  {r.authorName || t('reviews.admin_anon')}
                </span>
                {r.comment && <p className="admin-review__comment">“{r.comment}”</p>}
                <span className="rescue-item__meta">
                  {new Date(r.createdAt).toLocaleDateString()}
                  {r.steamId && ` · ${r.steamId}`}
                </span>
              </div>
              <div className="rescue-item__actions">
                <span className={`rescue-item__badge ${r.hidden ? 'is-wait' : 'is-ok'}`}>
                  {r.hidden ? t('reviews.admin_hidden') : t('reviews.admin_shown')}
                </span>
                <button className="admin__link" onClick={() => toggle(r)}>
                  {r.hidden ? t('reviews.admin_show') : t('reviews.admin_hide')}
                </button>
                <button className="admin__link admin__link--danger" onClick={() => remove(r)}>
                  {t('reviews.admin_delete')}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AdminReviews;
